type IDatePickerValue = string | string[];
enum PickerOptionsMode {
    multiple = 'multiple',
    range = 'range',
    single = 'single',
}
enum PickerType {
    date = 'date',
    week = 'week',
    month = 'month',
    quarter = 'quarter',
    year = 'year',
}
interface IFooterButItemInfo {
    key?: string;
    className?: string;
    label: string;
    type: any;
    onClick?: (key?: string) => void;
}
interface ICalendarInfo {
    mode: PickerType;
    value: string;
}
export {
    PickerType,
    ICalendarInfo,
    PickerOptionsMode,
    IDatePickerValue,
    IFooterButItemInfo
}